import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { customerIncidentSchema } from "@common/components/helpers/validation-schemas/customerIncidentSchema";
import CustomerIncidentAction from "@common/redux/actions/CustomerIncidentAction";
import { fetchPoliceId } from "@common/components/helpers/Officer/searchOfficer";
import { useSelector } from "react-redux";
import useCompliance from "./useCompliance";

export const useCustomerIncident = () => {
  const data = useSelector((state) =>
    CustomerIncidentAction.getStatePath(state),
  );

  const methods = useForm({
    defaultValues: data,
    resolver: yupResolver(customerIncidentSchema),
    mode: "all",
  });

  const { resetComplianceForms } = useCompliance(methods);

  const onBack = () => resetComplianceForms();

  useEffect(fetchPoliceId, []);

  return {
    methods,
    data,
    onBack,
  };
};
